module.exports = __webpack_public_path__ + "static/media/responsive.2db4be35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/responsive.svg
// module id = 1399
// module chunks = 0